<template lang="pug">
v-card( flat).d-flex.flex-column.overflow-auto.scroll
  v-card-text(style="height: 100%")
    v-row.mb-5.ma-0.align-center
      span.mr-2 Договор №
      strong {{ item.number }}
      v-btn.ml-3(
        v-if="item.preview_document"
        icon
        color="primary"
        @click="openPreviewDocument"
      ): v-icon mdi-file-eye
      v-spacer
      v-chip(
        :color="item.is_concluded ? 'success' : 'error'"
      ) {{item.is_concluded ? 'Активен' : 'Не активен'}}
    v-alert(
      text prominent
      :type="item.isPaymentPrePayment ? 'success' : 'error'"
    ).pa-10
      p.pl-6
        span.text-h6.mr-2: strong  Оплачено {{ item.paymentPercent }}%
        span {{ item.payment }} руб.
      p.ma-0.align-center.pl-6
        span из
        span.text-h5.mx-2: strong {{ item.sum_total }}₽
        span.text-decoration-line-through.error--text.pt-2(v-if="item.sumWhitoutDiscount")
          strong {{ item.sumWhitoutDiscount }}₽
    v-btn.mb-4(
      v-if="!isEnrollment && !item.typical_contract_discount"
      color="secondary lighten-1"
      small block text
      @click="item.openDiscountModal()"
    ) Установить скидку
    v-expansion-panels(flat v-model="panel")
      v-expansion-panel.v-expansion-panel--outlined
        v-expansion-panel-header.text-body-2 Список учащихся по данному договору
        v-expansion-panel-content(:style="`max-height: 200px`").overflow-auto.scroll
          v-list-item(v-for="(item, idx) in item.users" :key="idx")
            v-list-item-icon
              v-icon mdi-account
            v-list-item-content {{ item.full_name }}
            v-list-item-action

      v-expansion-panel.v-expansion-panel--outlined
        v-expansion-panel-header.text-body-2  История операций:
        v-expansion-panel-content(:style="`max-height: 200px`").overflow-auto.scroll
          v-alert(
            v-if="item.transactions && !item.transactions.length"
            type="info" outlined
          ) Не совершено ни одной транзакции
          v-col.pa-0.mb-4(
            v-for="tran in item.transactions" :key="tran.id"
          )
            v-row(nu-gutters)
              v-col
                v-list-item-subtitle.text-caption {{ paymentAt(tran) }}
                v-list-item-title(
                  :class=" tran.sum > 0 ? 'success--text' : 'error--text'"
                ): strong {{tran.sum > 0 ? 'Пополнение:' : 'Возврат'}}
              v-col.align-self-end
                div(:class=" tran.sum > 0 ? 'success--text' : 'error--text'").text-end
                  strong {{ tran.sum }} руб.
            v-divider
      sign-contract-panel(
        v-if="!userIsOwner"
        :contract="item"
        :isEnrollment="isEnrollment"
        @set="updateContractLocale"
      )

  v-card-actions
    v-btn(
      color="secondary"
      @click="openChat"
    )
      v-icon(left) mdi-chat
      | Открыть чат
    v-btn.ml-auto(
      v-if="(item.is_concluded || isEnrollment) && !item.isAllPayed"
      color="success"
      @click="item.openPaymentModal(isEnrollment)"
    ) {{ isEnrollment ? 'Сформировать квитанцию на оплату' : 'Внести платеж'}}
    v-btn.ml-auto(
      v-else-if="userIsOwner && !isEnrollment && !item.isAllPayed "
      color="primary"
      @click="concludeContract"
    ) Заключить контракт

</template>

<script>
import { format, parseISO } from 'date-fns';
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import EnrollmentElementFilters from '@/modules/CourseManagement/components/Enrollment/EnrollmentElementFilters.vue';
import Chat from '@/models/list/Chat';
import EnrollmentElementUser from '@/modules/CourseManagement/components/Enrollment//EnrollmentElementUser.vue';
import PreviewContract from './PreviewContract.vue';
import SignContractPanel from './SignContractPanel.vue';
import ContractChat from './ContractChat.vue';

export default {
  components: {
    ContractChat,
    EnrollmentElementFilters,
    EnrollmentElementUser,
    CrudScrollDetails,
    SignContractPanel,
  },
  props: {
    isEnrollment: { type: Boolean, default: false },
    item: { type: Object, default: null },
  },
  data() {
    return {
      panel: 2,
      changeSumMode: false,
      format,
      parseISO,
    };
  },
  computed: {
    userIsOwner() {
      const { owner_id: ownerId, users: [{ id }] } = this.item;
      console.log(id);
      return ownerId === id;
    },
  },
  mounted() {
    if (this.$route.query.payment) this.item.openPaymentModal(this.isEnrollment);
  },
  methods: {
    async concludeContract() {
      const payload = {
        id: this.item.id,
        is_conclude: true,
      };
      this.$rHandler(
        this.$api.contracts.updateContracts(payload),
        () => {
          this.updateContractLocale({ ...this.item, is_conclude: true });
        },
      );
    },
    updateContractLocale(value) {
      this.$set(this, 'contract', value);
    },
    async openChat() {
      const room = await this.$api.contracts.getRoomContract(this.item.id);
      const chat = new Chat(room.data.data);
      this.$chat.set(chat, {
        opened: true,
        title: 'Чат по договору:',
        subtitle: this.item.number,
      });
    },
    paymentAt(item) {
      return format(new Date(item.created_at), 'dd.MM.yyyy');
    },
    openPreviewDocument() {
      this.$modals.show('generic-controller', {
        component: PreviewContract,
        title: 'Предпросмотр',
        dialogProps: {
          width: 800,
        },
        'component-props': {
          previewDocument: this.item.preview_document,
        },
      });
    },
  },
};
</script>
